<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title text-primary">Detalhes da Entrega do E-mail</h3>
    </div>
    <ul class="list-group">
      <li class="list-group-item">Ocorrido em: <strong>{{ carimboEmailEntregue.ocorridoEm }}</strong></li>
      <li class="list-group-item">Carimbo (base64): <pre id="carimbo">{{ carimboEmailEntregue.carimbo }}</pre></li>
      <li class="list-group-item">Conteúdo: <pre class="carimbo">{{ carimboEmailEntregue.conteudo }}</pre></li>
      <li class="list-group-item">Hash: <strong>{{ carimboEmailEntregue.hashAssinado }}</strong></li>
      <li class="list-group-item">Serial: <strong>{{ carimboEmailEntregue.serial }}</strong></li>
      <li class="list-group-item">Emitido Por: <a href="https://www.documentoeletronico.com.br/" target="_blank"><strong>{{ carimboEmailEntregue.emitidoPor }}</strong></a></li>
      <li class="list-group-item">Algoritmo: <strong>{{ carimboEmailEntregue.algoritimo }}</strong></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'AppInfoEmailQualisoftDeliveryDetails',

  props: {
    carimboEmailEntregue: {
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-qualisoft/InfoEmailQualisoftDeliveryDetails.vue